<template>
  <div id="app" class="flex flex-col h-screen w-full content">
    <!-- This example requires Tailwind CSS v2.0+ -->
    <div v-if="$router.currentRoute.name !== 'Login'" class="h-15 bg-gray-800">
      <div class="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
        <div class="relative flex items-center justify-between h-16">
          <div class="absolute inset-y-0 left-0 flex items-center sm:hidden">
            <!-- Mobile menu button-->
<!--            <button class="inline-flex items-center justify-center p-2 rounded-md
text-gray-400-->
<!--            hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2
focus:ring-inset-->
<!--            focus:ring-white" aria-expanded="false">-->
<!--              <span class="sr-only">Open main menu</span>-->
<!--              &lt;!&ndash; Icon when menu is closed. &ndash;&gt;-->
<!--              &lt;!&ndash;-->
<!--                Heroicon name: menu-->

<!--                Menu open: "hidden", Menu closed: "block"-->
<!--              &ndash;&gt;-->
<!--              <svg class="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none"-->
<!--                   viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">-->
<!--                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"-->
<!--                      d="M4 6h16M4 12h16M4 18h16" />-->
<!--              </svg>-->
<!--              &lt;!&ndash; Icon when menu is open. &ndash;&gt;-->
<!--              &lt;!&ndash;-->
<!--                Heroicon name: x-->

<!--                Menu open: "block", Menu closed: "hidden"-->
<!--              &ndash;&gt;-->
<!--              <svg class="hidden h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none"-->
<!--                   viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">-->
<!--                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"-->
<!--                      d="M6 18L18 6M6 6l12 12" />-->
<!--              </svg>-->
<!--            </button>-->
          </div>
          <div class="flex-1 flex items-center justify-center sm:items-stretch sm:justify-start">
            <div class="flex-shrink-0 flex items-center">
<!--              <svg width="150" height="50" id='logoipsum' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 177.778 100'><path d='M41.419,48.371A3.656,3.656,0,0,0,40.373,51.3l-.018-.018a4.344,4.344,0,0,1-4.694,4.694l.018.018A3.678,3.678,0,1,0,39,59.312l.019.018a4.344,4.344,0,0,1,4.694-4.694l-.019-.018a3.671,3.671,0,1,0-2.272-6.247Z' fill='#394149'/><path d='M34.042,53.636l-.019-.018A3.631,3.631,0,0,0,38,49.644l.019.018a4.344,4.344,0,0,1,4.694-4.694l-.019-.018a3.678,3.678,0,1,0-3.318-3.318l-.018-.019a4.343,4.343,0,0,1-4.694,4.694l.018.019A3.631,3.631,0,0,0,30.705,50.3l-.018-.018a4.345,4.345,0,0,1-4.694,4.694l.018.018a3.678,3.678,0,1,0,3.318,3.318l.019.018A4.344,4.344,0,0,1,34.042,53.636Z' fill='#394149'/><path d='M27.34,51.629A3.652,3.652,0,0,0,28.385,48.7l.019.018A4.344,4.344,0,0,1,33.1,44.024l-.019-.018a3.677,3.677,0,1,0-3.318-3.318l-.018-.018a4.344,4.344,0,0,1-4.694,4.694l.018.018a3.671,3.671,0,1,0,2.273,6.247Z' fill='#394149'/><path d='M58.317,41.655h2.97V56.108h-2.97Z' fill='#394149'/><path d='M62.969,51.159a5.247,5.247,0,1,1,5.247,5.226A5.188,5.188,0,0,1,62.969,51.159Zm7.524,0A2.278,2.278,0,1,0,68.216,53.5,2.221,2.221,0,0,0,70.493,51.159Z' fill='#394149'/><path d='M85.3,46.209v9.4c0,3.326-2.594,4.732-5.227,4.732a5.062,5.062,0,0,1-4.692-2.4l2.534-1.465a2.262,2.262,0,0,0,2.257,1.247,1.973,1.973,0,0,0,2.237-2.118V54.7a3.516,3.516,0,0,1-2.891,1.287,5.031,5.031,0,0,1,0-10.057,3.516,3.516,0,0,1,2.891,1.287v-1.01ZM82.41,50.96a2.4,2.4,0,1,0-2.395,2.3A2.24,2.24,0,0,0,82.41,50.96Z' fill='#394149'/><path d='M86.982,51.159a5.247,5.247,0,1,1,5.247,5.226A5.188,5.188,0,0,1,86.982,51.159Zm7.524,0A2.278,2.278,0,1,0,92.229,53.5,2.221,2.221,0,0,0,94.506,51.159Z' fill='#394149'/><path d='M98.861,43.556a1.782,1.782,0,1,1,1.782,1.782A1.8,1.8,0,0,1,98.861,43.556Zm.3,2.653h2.971v9.9H99.157Z' fill='#394149'/><path d='M114.956,51.159a4.971,4.971,0,0,1-4.732,5.226,3.715,3.715,0,0,1-2.949-1.208v4.891h-2.97V46.209h2.97v.93a3.717,3.717,0,0,1,2.949-1.207A4.97,4.97,0,0,1,114.956,51.159Zm-2.97,0a2.356,2.356,0,1,0-2.355,2.415A2.26,2.26,0,0,0,111.986,51.159Z' fill='#394149'/><path d='M124.121,53.138c0,2.277-1.979,3.247-4.117,3.247a4.335,4.335,0,0,1-4.257-2.356l2.573-1.465A1.627,1.627,0,0,0,120,53.732c.712,0,1.069-.218,1.069-.613,0-1.09-4.871-.515-4.871-3.94,0-2.159,1.822-3.247,3.881-3.247a4.329,4.329,0,0,1,3.86,2.118l-2.534,1.366a1.437,1.437,0,0,0-1.326-.871c-.515,0-.832.2-.832.554C119.251,50.228,124.121,49.475,124.121,53.138Z' fill='#394149'/><path d='M134.97,46.209v9.9H132v-.931a3.382,3.382,0,0,1-2.83,1.208c-2,0-3.7-1.425-3.7-4.1V46.209h2.97v5.642a1.632,1.632,0,0,0,1.722,1.8c1.089,0,1.841-.633,1.841-2.039v-5.4Z' fill='#394149'/><path d='M152,50.03v6.078h-2.97V50.287c0-.99-.475-1.623-1.425-1.623-.99,0-1.545.693-1.545,1.861v5.583h-2.969V50.287c0-.99-.475-1.623-1.426-1.623-.99,0-1.544.693-1.544,1.861v5.583h-2.97v-9.9h2.97v.91a3.039,3.039,0,0,1,2.653-1.187,2.945,2.945,0,0,1,2.593,1.306,3.262,3.262,0,0,1,2.871-1.306C150.511,45.932,152,47.555,152,50.03Z' fill='#394149'/><circle cx='154.512' cy='43.944' r='2.204' fill='#394149'/></svg>-->
<!--              <img class="block lg:hidden h-8 w-auto"-->
<!--                   src="https://tailwindui.com/img/logos/workflow-mark-indigo-500.svg" alt="Workflow">-->
<!--              <img class="hidden lg:block h-8 w-auto"-->
<!--                   src="https://tailwindui.com/img/logos/workflow-logo-indigo-500-mark-white-text.svg"-->
<!--                   alt="Workflow">-->
            </div>
            <div class="flex items-center  hidden sm:block sm:ml-6">
              <div class="flex items-center h-full space-x-4">
                <!-- Current: "bg-gray-900 text-white", Default: "text-gray-300
                hover:bg-gray-700 hover:text-white" -->
                <router-link to="/" class="text-gray-300 hover:bg-gray-700 hover:text-white
                px-3 py-2 rounded-md text-sm font-medium"
                             :class="[$router.currentRoute.name == 'Home' ? 'bg-gray-900' : '']">
                  Board</router-link>
                <router-link v-if="$store.getters['auth/user'] &&
                $store.getters['auth/user'].role === 'admin'" to="/admin"
                             class="text-gray-300 hover:bg-gray-700 hover:text-white
                px-3 py-2 rounded-md text-sm font-medium"
                             :class="[$router.currentRoute.name == 'Admin' ? 'bg-gray-900' : '']">
                  Verwaltung</router-link>
                <router-link to="/reklamation"
                             class="text-gray-300 hover:bg-gray-700 hover:text-white
                px-3 py-2 rounded-md text-sm font-medium"
                 :class="[$router.currentRoute.name == 'Reklamationen' ? 'bg-gray-900' : '']">
                  Reklamationen</router-link>
              </div>
            </div>
          </div>
          <div class="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto
          sm:ml-6 sm:pr-0">
            <div class="text-gray-300 text-sm font-medium">
              Benutzer: {{ $store.getters['auth/user'] != null ?
              $store.getters['auth/user'].first_name : '' }}
              {{ $store.getters['auth/user'] != null ? $store.getters['auth/user'].last_name : '' }}
            </div>
            <!-- Profile dropdown -->
            <div @click="toggleMenu = !toggleMenu" class="ml-3 relative">
              <div>
                <div class="bg-gray-800 flex text-sm rounded-full cursor-pointer"
                        id="user-menu" aria-haspopup="true">
                  <span class="sr-only">Open user menu</span>
                  <svg class="h-8 w-8" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="#fff"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z" clip-rule="evenodd" /></svg>
                </div>
              </div>
              <div v-if="toggleMenu" class="origin-top-right absolute right-0 mt-2 w-48 rounded-md
              shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 z-50" role="menu"
                   aria-orientation="vertical" aria-labelledby="user-menu">
                <a @click.prevent="$refs['modal-login'].isShown = true; getUsernames();"
                   class="block px-4
                py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
                   role="menuitem">Benutzer wechseln</a>
                <router-link to="/settings" class="block px-4 py-2 text-sm text-gray-700
                hover:bg-gray-100" role="menuitem">Einstellungen</router-link>
                <a @click="signOut" class="block px-4 py-2 text-sm text-gray-700 cursor-pointer
                hover:bg-gray-100" role="menuitem">Abmelden</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex-1 h-full w-full">
      <router-view></router-view>
    </div>
    <ModalSm ref="modal-login"
           customClass="h-30 w-1/5">
      <template v-slot:header>
        Benutzer wechseln
      </template>
      <template v-slot:body>
        <p class="text-gray-700 font-sans tracking-wide text-sm">
          Benutzernamen wählen
        </p>
        <SelectCom name="username" label="Benutzername" v-model="form.username"
                   :options="usernameOptions"
                   :val="form.username"></SelectCom>
        <InputCom name="password" label="Passwort" input-type="password"
                  v-model="form.password"></InputCom>
      </template>
      <template v-slot:footer>
        <AnimatedButton @click.native="signIn('button-login')"
                        on-initial="Anmelden"
                        on-load="Laden..."
                        on-success="Angemeldet!"
                        on-error="Fehlgeschlagen!"
                        :ref="'button-login'"
                        :pause="750"
                        @reset="$refs['modal-login'].isShown = false;"
                        class="ml-2 float-right">
        </AnimatedButton>
      </template>
    </ModalSm>
  </div>
</template>

<script>
import ModalSm from '@/components/Util/ModalSm.vue';
import InputCom from '@/components/Util/InputCom.vue';
import SelectCom from '@/components/Util/SelectCom.vue';
import AnimatedButton from '@/components/Util/AnimatedButton.vue';
import axios from 'axios';

export default {
  name: 'App',
  components: {
    ModalSm,
    InputCom,
    AnimatedButton,
    SelectCom,
  },
  computed: {
    usernameOptions() {
      const options = [];
      this.usernames.forEach((u) => {
        options.push({ name: u.username, db: u.username });
      });
      return options;
    },
  },
  data() {
    return {
      toggleMenu: false,
      modalOpen: false,
      form: {
        username: '',
        password: '',
      },
      usernames: [],
    };
  },
  methods: {
    signIn(button) {
      if (typeof this.$refs[button] !== 'undefined') this.$refs[button].loadState = 'loading';
      axios.post('login', this.form).then((r) => {
        this.$store.commit('auth/SET_AUTH_TOKEN', r.data.access_token);
        this.$toast.open({
          message: 'Erfolgreich angemeldet!',
          type: 'success',
        });
        this.testLogin();
        if (typeof this.$refs[button] !== 'undefined') this.$refs[button].loadState = 'success';
      }).catch((error) => {
        this.$toast.open({
          message: error.response.data.message,
          type: 'error',
        });
        if (typeof this.$refs[button] !== 'undefined') this.$refs[button].loadState = 'error';
      });
    },
    signOut() {
      axios.post('logout', {}, { headers: { Authorization: `Bearer ${this.$store.getters['auth/authToken']}` } })
        .then(() => {
          this.$toast.open({
            message: 'Abgemeldet',
            type: 'info',
          });
        })
        .catch((error) => {
          this.$toast.open({
            message: error,
            type: 'error',
          });
        });
      this.$router.push('/login').catch(() => {});
    },
    testLogin() {
      axios.get('user', { headers: { Authorization: `Bearer ${this.$store.getters['auth/authToken']}` } }).then((response) => {
        this.$store.commit('auth/SET_AUTHENTICATED', true);
        this.$store.commit('auth/SET_USER', response.data);
        this.$router.push('/').catch(() => {});
        return 'success';
      }).catch(() => {
        this.$store.commit('auth/SET_AUTH_TOKEN', null);
        this.$store.commit('auth/SET_AUTHENTICATED', false);
        this.$store.commit('auth/SET_USER', null);
        return 'error';
      });
    },
    getUsernames() {
      this.$axios.get('usernames',
        { headers: { Authorization: `Bearer ${this.$store.getters['auth/authToken']}` } })
        .then((response) => {
          this.usernames = response.data.data;
        })
        .catch(() => {
          // console.log(error);
        });
    },
  },
};
</script>

<style scoped>

.content {
  height: calc(100vh - 110px)!important;
}

</style>
